import { defineMessages } from 'react-intl';

export default defineMessages({
  realtors: {
    id: 'Unknown.RealtorsScreen.realtors',
    defaultMessage: 'Realtors'
  },
  name: {
    id: 'Unknown.RealtorsScreen.name',
    defaultMessage: 'Name'
  },
  email: {
    id: 'Unknown.RealtorsScreen.email',
    defaultMessage: 'Email'
  },
  partners: {
    id: 'Unknown.RealtorsScreen.partners',
    defaultMessage: 'Partners'
  },
  actions: {
    id: 'Unknown.RealtorsScreen.actions',
    defaultMessage: 'Actions'
  },
  updatePartners: {
    id: 'Unknown.RealtorsScreen.updatePartners',
    defaultMessage: 'Update Partners'
  },
  noRealtors: {
    id: 'Unknown.RealtorsScreen.noRealtors',
    defaultMessage: 'No realtors found'
  },
  loading: {
    id: 'Unknown.RealtorsScreen.loading',
    defaultMessage: 'Loading...'
  },
  search: {
    id: 'Unknown.RealtorsScreen.search',
    defaultMessage: 'Search by name, email or partner'
  },
  cancel: {
    id: 'Unknown.RealtorsScreen.cancel',
    defaultMessage: 'Cancel'
  },
  save: {
    id: 'Unknown.RealtorsScreen.save',
    defaultMessage: 'Save'
  },
  status: {
    id: 'Unknown.RealtorsScreen.status',
    defaultMessage: 'Status'
  },
  signUpDate: {
    id: 'Unknown.RealtorsScreen.signUpDate',
    defaultMessage: 'Sign up Date'
  },
  trialEnds: {
    id: 'Unknown.RealtorsScreen.trialEnds',
    defaultMessage: 'Trial Ends'
  },
  activate: {
    id: 'Unknown.RealtorsScreen.activate',
    defaultMessage: 'Activate'
  },
  deactivate: {
    id: 'Unknown.RealtorsScreen.deactivate',
    defaultMessage: 'Deactivate'
  },
  delete: {
    id: 'Unknown.RealtorsScreen.delete',
    defaultMessage: 'Delete'
  },
  confirmActivateTrial: {
    id: 'Unknown.RealtorsScreen.confirmActivateTrial',
    defaultMessage:
      'Activate {name}? This action is irreversible: the trial period will be removed and the account will get full access.'
  },
  confirmDeactivate: {
    id: 'Unknown.RealtorsScreen.confirmDeactivate',
    defaultMessage: 'Deactivate {name}? They will no longer be able to log in.'
  },
  confirmDelete: {
    id: 'Unknown.RealtorsScreen.confirmDelete',
    defaultMessage:
      'Are you sure you want to delete {name}? All their clients and calculations will be permanently deleted.'
  }
});
